import { render, staticRenderFns } from "./BloodResultsForm.vue?vue&type=template&id=4e296b8e"
import script from "./BloodResultsForm.vue?vue&type=script&lang=js"
export * from "./BloodResultsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports